export default "__VITE_ASSET__$FhZ4keQ__"